module.exports = __webpack_public_path__ + "img/744.02013cf7.jpg";